import styled from 'styled-components';

export const PromotionsSlider = styled.div`
  width: 100%;
  margin-top: 10px;
  
  .swiper-container {
    margin: 0 -20px;
    padding: 0 20px;
    padding-bottom: 30px;
  }
`;

export const OurPromotionsSlide = styled.div`
  height: auto;
`;

export const OurPromotionsNavigation = styled.div`
  display: flex;
  
  @media(min-width: 1320px) {
    position: absolute;
    z-index: 1;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    
    justify-content: space-between;
    width: 1320px;
    margin-top: 30px;
  }
`;

export const OurPromotionsButton = styled.button`
  margin: 0;
  padding: 0;
  
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  
  border: 2px solid ${({ theme }) => theme.blue};
  border-radius: 50%;
  outline: none;
  background-color: transparent;
  
  cursor: pointer;
  
  svg {
    transform: rotate(90deg);
    fill: ${({ theme }) => theme.blue};
    stroke: ${({ theme }) => theme.blue};
  }
  
  &:last-child {
    margin-left: 8px;
    
    svg {
      transform: rotate(-90deg);
    }
  }
  
  @media(min-width: 1320px) {
    &:last-child {
      margin-left: 0;
    }
  }
`;
